import React, {useMemo} from "react";
import {Dialog, DialogActions, DialogContent, IconButton, Typography} from "@mui/material";
import {Delete as DeleteIcon, Edit as EditIcon} from "@mui/icons-material";
import {ClosableDialogTitle, UserAvatar} from "@atttomyx/react-components";
import {Actions} from "../node";
import {arrays, datetime} from "@atttomyx/shared-utils";

const EventDialog = (props) => {
    const { event, onCancel, onGotoNode, onEditTask, onDeleteTask } = props;
    const { node, date, task} = event;

    const description = useMemo(() => {
        return task ? arrays.splitOnNewline(task.description) : null;
    }, [task]);

    return <Dialog
        open={true}
        aria-labelledby="event-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            {task ? task.title : <UserAvatar user={node} mode="right"/>}
        </ClosableDialogTitle>
        <DialogContent className="item-dialog">
            {task ?
                <>
                    {description.map((line, index) =>
                        <Typography variant="caption" component="p" paragraph={index === description.length - 1}>
                            {line}
                        </Typography>)}
                    <Typography variant="body1">
                        {task.dueAt
                            ? datetime.getFullDateAndTime(task.dueAt)
                            : datetime.getFullDate(task.dueOn)}
                    </Typography>
                </> :
                <>
                    <Typography variant="caption" color="text.secondary">
                        {date.label}
                    </Typography>
                    <Typography variant="body1">
                        {datetime.getFullDate(date.value)}
                    </Typography>
                </>}
        </DialogContent>
        <DialogActions>
            {task ?
                <IconButton
                    color="secondary"
                    title="Delete"
                    className="delete"
                    onClick={() => onDeleteTask(task)}
                >
                    <DeleteIcon/>
                </IconButton> : null}
            {node ?
                <Actions
                    node={node}
                /> : null}
            <IconButton
                color="primary"
                title="Edit"
                onClick={task
                    ? () => onEditTask(task)
                    : () => onGotoNode(node.id)}
            >
                <EditIcon/>
            </IconButton>
        </DialogActions>
    </Dialog>
}

export default EventDialog;
